export default __webpack_public_path__ + "static/media/lee.d34d34f3.svg";